// import { getGalileoAb } from '@/shared/galileoAb';
import { canAndroidOcrUse, canIOSOcrUse } from '@/shared/tools/ocr/utils/env';
import { getSDKInstallStatus } from '@/shared/tools/ocr/utils/native';

// import { ExperimentResEnum } from '@/enums/abExperiment';

// const OCR_EXPERIMENT_RESULT_SESSION_KEY = 'ocr_experiment_result_key';
// const EXPERIMENT_ID = '202501061506421229';
// const CONTROL_ID = '202501061506421293';

/**
 * 命中实验组，ab api平均耗时100ms
 * 实验地址：https://ab.hellobike.cn/experiment/detail/202501061506421229?isDetail=true
*/
export const checkOcrMatchExperiment = (): boolean => {
  try {
    /** Android 已推全，支持使用的环境，返回true */
    if (canAndroidOcrUse) return true;

    /** IOS 已推全，支持使用的环境，返回true */
    if (canIOSOcrUse) return true;

    /** 后面鸿蒙的实验 复用这段代码 */
    // if (canIOSOcrUse) {
    //   const ocrSession = sessionStorage.getItem(OCR_EXPERIMENT_RESULT_SESSION_KEY);
    //   if (ocrSession) {
    //     return ocrSession === ExperimentResEnum.EXPERIMENT;
    //   }

    //   const res = await getGalileoAb().getAbRes(EXPERIMENT_ID, CONTROL_ID);
    //   sessionStorage.setItem(OCR_EXPERIMENT_RESULT_SESSION_KEY, res.result);

    //   if (res.result === ExperimentResEnum.EXPERIMENT) {
    //     return true;
    //   }
    // }
  } catch {
    // 异常不阻塞流程，暂不处理
  }

  return false;
};

/** OCR SDK已安装 */
export const checkOcrSdkInstalled = async (): Promise<boolean> => {
  try {
    if (canAndroidOcrUse || canIOSOcrUse) {
      const OcrSdkInstallStatus = await getSDKInstallStatus();
      if (OcrSdkInstallStatus.hasInstalled) {
        return true;
      }
    }
  } catch {
    // 异常不阻塞流程，暂不处理
  }

  return false;
};

/** 是否使用实验组流程 */
export const checkUseOcrExperiment = async (): Promise<boolean> => {
  const isMatchExperiment = checkOcrMatchExperiment();
  const isOcrSdkInstalled = await checkOcrSdkInstalled();

  return isMatchExperiment && isOcrSdkInstalled;
};
